// extracted by mini-css-extract-plugin
module.exports = {"agentInfo":"AgentInformationPanel_agentInfo__2mqaJ"};